import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

import { Input, Select } from 'components/ui';
import { FormControlLabel, Checkbox, Collapse } from '@mui/material';
import BillzTypography from 'components/BillzTypographies/BillzTypography';

import * as Styled from './General.styles';
import { getProductTypes } from 'utility/productTypes';
import { getUnits } from 'utility/units';

export const General = ({ form, setToastData }) => {
    const { values, errors, setFieldValue, setFieldError, setValues } = form;

  return (
    <Styled.Wrapper>
      <Input
        onChange={(value) => setFieldValue('name', value)}
        value={values.name}
        label="Nazwa*"
        error={errors.name}
      />
      <Input
        onChange={(value) => setFieldValue('pkWiU', value)}
        value={values.pkWiU}
        label="PKWiU"
        error={errors.pkWiU}
      />
      <Select
        onChange={(value) => setFieldValue('unit', value)}
        value={values.unit}
        label="Jednostka"
        error={errors.unit}
        options={getUnits().map((unit) => { return {value: unit, label: unit}})}
      />
      <Input
        onChange={(value) => setFieldValue('unitNetPrice', value)}
        value={values.unitNetPrice}
        label="Cena netto"
        error={errors.unitNetPrice}
      />
      <Select 
        onChange={(value) => setFieldValue('type', value)}
        value={values.type}
        label="Rodzaj"
        error={errors.type}
        options={getProductTypes()}
      />
    </Styled.Wrapper>
  );
};

General.propTypes = {
  form: PropTypes.object.isRequired,
  setToastData: PropTypes.func.isRequired
};
